import React from 'react'
import CreditItem from './CreditItem'

const CreditsList = ({credits}) => {
	if (!credits || credits.length === 0) {
		return null
	}

	return (
			<div className='border-top'>
				<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							width: '100%',
							marginTop: 20
						}}
				>
					{credits.map((credit, index) => (
							<CreditItem
									key={credit.id ?? `${credit.name || 'credit'}-${index}`}
									credit={credit}
									index={index}
									totalCredits={credits.length}
							/>
					))}
				</div >
			</div >
	)
}

export default CreditsList

